import { z } from "zod";
/**
 * Materializes the result of an envelope-extraction job onto a section. Padrão
 * idêntico ao `SectionStemsBound`: o worker emite primeiro o evento operacional
 * `EnvelopeExtracted` (idempotência / trilha de auditoria do job) e depois este
 * evento musical, que é o que o reducer consome para materializar
 * `Section.envelope` no `AudioState`.
 *
 * O payload carrega a envelope inline (array de floats por stem) — ~10 KB por
 * seção no SQLite local, aceitável (spec §4.1, D2).
 */
export const sectionEnvelopeExtractedPayloadSchema = z.object({
    sectionId: z.string().min(1),
    // Hz de amostragem da envelope (frames por segundo). Fixo, mas gravado para
    // que o consumidor não precise adivinhar.
    sampleRateHz: z.number().int().positive().max(120),
    // Série temporal de energia RMS normalizada [0,1] por stem. Chave = nome do
    // stem (drums, bass, vocals, other), igual a `SectionStemsBound`.
    stems: z
        .record(z.string().min(1), z.array(z.number().min(0).max(1)))
        .refine((r) => Object.keys(r).length > 0, {
        message: "envelope must contain at least one stem",
    }),
});
//# sourceMappingURL=envelope.js.map